import 'flowbite'
import dayjs from 'dayjs'
import {useRef, useState } from 'react'
import {  getHazardName, setPanAlertLocation} from '../AlertingSlice/AlertingSlice'
import { useDispatch } from 'react-redux'
import clsx from 'clsx'
import * as turf from 'turf';
import {useClickAway} from 'react-use';

const AlertNotificationBox = (props) => {
  let alertsData = props?.properties || []  
  const [currentAlertIndex, setCurrentAlertIndex] = useState(0)
  const dispatch = useDispatch()

  const handlePanning = (currentAlert) => {
    try {
      let alertPolygon = currentAlert
      if(currentAlert.type == "Polygon"){
        alertPolygon = {
          ...alertPolygon,
          coordinates: alertPolygon.coordinates.map(ring =>
              ring.map(([lat, lon]) => [lon, lat])
            )
        }
      }
      
      let centroid = turf.center(alertPolygon);      
      const position = currentAlert
      ? {
          lat: centroid?.geometry?.coordinates[1],
          lng: centroid?.geometry?.coordinates[0],
        } : null;
      dispatch(setPanAlertLocation(position))
    } catch (error) {
      console.log(error);
      dispatch(setPanAlertLocation(null))
    }
  }  
  const handleSelection = (index) => {
    setCurrentAlertIndex(index)
    const currentAlert = alertsData[currentAlertIndex];
    handlePanning(currentAlert)
  }
  const handleCloseAlert = () => {
    props.onClose()
  }
  const formatDate = (date: string) => {    
    const formatted = dayjs(date).format('MMM D - h:mm A')
    return formatted
  }
  const ref = useRef(null);
  useClickAway(ref, () => {
    props.onClose()
  });

  return (
    <div className="fixed top-16 right-20 w-80 max-h-96 h-auto border bg-[#F8F8F8] border-gray-500 rounded-lg flex flex-col z-[9999] p-2" ref={ref}>
      <div className="rounded-t-lg text-black flex items-center justify-between font-semibold text-base">
        <span className="uppercase">Alerts</span>
        <button className="text-black p-2 hover:text-gray-700 hover:bg-gray-200 rounded flex items-center justify-center transition z-1000" onClick={handleCloseAlert} >
          &#x2715;
        </button>
      </div>
      <hr />
      <div className="flex flex-1 flex-col  gap-2 p-2 overflow-y-auto">
        {
          alertsData.map((item, index) =>
            <div className={
              clsx("flex flex-col bg-white rounded-lg items-center hover:bg-gray-100 border border-[#94a3b8] cursor-pointer p-2", 
                index == currentAlertIndex && "border-2 border-twsBlue"
              )
            } onClick={() => handleSelection(index)}>
              <div className='flex items-center justify-between gap-2 w-full'>
                  <p className="text-center text-base font-semibold text-[#1e293b] uppercase">
                  { item?.properties.triggerEvent || "Sensor Alert"}
                </p>
                <p className="text-center text-[#64748B] break-words text-xs uppercase font-semibold">
                  {formatDate( item?.properties.validAt || item?.properties?.alerts[0]["validAt"])}
                </p>
              </div>
              <p className="flex items-center text-center justify-center gap-2 w-full text-sm font-semibold items-center border rounded-lg p-2 justify-center uppercase bg-[#FFE5E5] text-[#A03333]">
                  {getHazardName(item?.properties.hazardType) || item?.properties?.sensor}
              </p>     
            </div>
          ) 
        }
      </div>
    </div>
  )
}
export default AlertNotificationBox

